import { Component, Input } from '@angular/core';

import { trackById } from '../../../shared/util';

@Component({
  selector: 'lum-picklist-item-location-breakdown',
  templateUrl: './picklist-item-location-breakdown.component.html',
  styleUrls: ['./picklist-item-location-breakdown.component.scss'],
})
export class PicklistItemLocationBreakdownComponent {
  @Input()
  locations :any[]; // TODO: CREATE  INTERFACE

  @Input()
  loading :boolean;

  trackById = trackById;
}
